import { Row, Col, Form, Menu, Checkbox, Input } from "antd";
import { Card } from "react-bootstrap";

import Button from "antd-button-color";

const categoryList = [
  {
    label: "Tenda",
    value: "Tenda",
  },
  {
    label: "Panggung",
    value: "Panggung",
  },
  {
    label: "Kipas/AC",
    value: "Kipas/AC",
  },
  {
    label: "Pemiosan",
    value: "Pemiosan",
  },
  {
    label: "Wedding",
    value: "Wedding",
  },
  {
    label: "Karpet",
    value: "Karpet",
  },
  {
    label: "Sound Sistem",
    value: "Sound Sistem",
  },
  {
    label: "Keramik",
    value: "Keramik",
  },
  {
    label: "Melamin",
    value: "Melamin",
  },
  {
    label: "Kain",
    value: "Kain",
  },
  {
    label: "Kursi",
    value: "Kursi",
  },
  {
    label: "Meja",
    value: "Meja",
  },
  {
    label: "TV",
    value: "TV",
  },
];

const renderTitle = (title) => <b className="text-dark">{title}</b>;

const SidebarContainer = () => {
  return (
    <>
      <h6>Filter</h6>
      <Card className="border-0 card-filter">
        <Card.Body>
          <Menu
            mode="inline"
            className="filter-menu user-select-none"
            defaultOpenKeys={["category", "price"]}
          >
            <Menu.SubMenu key="category" title={renderTitle("Kategori")}>
              <Checkbox.Group className="w-100">
                <Row gutter={[10, 5]}>
                  {categoryList.map((data) => (
                    <Col span={24} key={data.value}>
                      <Checkbox
                        value={data.value}
                        label="sdadasdas"
                        className="rating-checkbox w-100"
                      >
                        <span className="text-secondary">{data.label}</span>
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            </Menu.SubMenu>

            <Menu.SubMenu key="price" title={renderTitle("Harga")} className="mt-3">
              <Form layout="vertical">
                <Form.Item label="Harga Minimum" className="m-b-10">
                  <Input placeholder="Harga Minimum" />
                </Form.Item>
                <Form.Item label="Harga Maximum">
                  <Input placeholder="Harga Maximum" />
                </Form.Item>
              </Form>
            </Menu.SubMenu>

            <Button block type="dark" className="mx-auto" onClick={() => {}}>
              Terapkan
            </Button>
          </Menu>
        </Card.Body>
      </Card>
    </>
  );
};

export default SidebarContainer;
